export default __webpack_public_path__ + "528ea0e602fdfd5e0d34b3b9a5f670ed.svg";